import { useSearchParams } from 'react-router-dom';

export const useIsEmbedded = () => {
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source') || 'redirected';
  const isEmbedded = source === 'embbeded' || source === 'embedded';

  return {
    isEmbedded,
  };
};
